import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import {
  PropertyStateArgsProps,
  PropertyStateFieldConfig,
  PropertyStateFields,
  PropertyStatePaths,
  PropertyStateTableCellProps,
  PropertyStateTableHeaderCellProps,
  TableCellProps,
  TableHeaderCellProps,
} from '@hcs/types';
import { formatMoney } from '@hcs/utils';

const FIELD = PropertyStateFields.concessionSellerAmount;
type FieldConfig = PropertyStateFieldConfig<typeof FIELD>;
const label = 'Concession Seller Amount';
const labelShort = 'Seller Concession';
const propertyStatePath: PropertyStatePaths =
  '/listingDetailsSale/concessions/sellerAmount';

const getValue: FieldConfig['getValue'] = (propertyStateArgs) => {
  const { propertyState, propertyStateType } = propertyStateArgs || {};
  if (propertyStateType === 'flat') {
    return propertyState?.[FIELD];
  } else if (propertyStateType === 'Core') {
    return propertyState?.listingDetailsSale?.concessions?.sellerAmount;
  }
  return undefined;
};

const formatValue: FieldConfig['formatValue'] = (propertyStateArgs) =>
  formatMoney(getValue(propertyStateArgs));

const formatInline: FieldConfig['formatInline'] = (propertyStateArgs) =>
  `${formatValue(propertyStateArgs)}`;

// eslint-disable-next-line react-refresh/only-export-components
const Display = ({ propertyStateArgs }: PropertyStateArgsProps) => {
  return <>{formatValue(propertyStateArgs)}</>;
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = (props: PropertyStateTableHeaderCellProps) => {
  return <TableHeaderCell {...props}>{labelShort}</TableHeaderCell>;
};

const defaultHeaderProps: Partial<TableHeaderCellProps> = {
  align: 'right',
  isTableHeaderCell: true,
};
HeaderCell.defaultProps = defaultHeaderProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({
  propertyStateArgs,
  ...tableCellProps
}: PropertyStateTableCellProps) => {
  return (
    <TableCell {...tableCellProps}>
      <Display propertyStateArgs={propertyStateArgs} />
    </TableCell>
  );
};

const defaultContentProps: Partial<TableCellProps> = {
  align: 'right',
  isTableCell: true,
};
ContentCell.defaultProps = defaultContentProps;

export const CONCESSION_SELLER_AMT: FieldConfig = {
  field: FIELD,
  label,
  labelShort,
  propertyStatePath,
  getValue,
  formatValue,
  formatInline,
  HeaderCell,
  ContentCell,
  Display,
};
